<template>
  <div class="kv-ve-align kv-ve-align--vertical" role="group" :aria-label="resolvedLabel">
    <button
      type="button"
      class="kv-ve-align__btn"
      :class="{ active: safeValue === 'top' }"
      :title="resolvedTopTitle"
      :aria-label="resolvedTopTitle"
      :aria-pressed="safeValue === 'top' ? 'true' : 'false'"
      @click="set('top')"
    >
      <span class="mdi mdi-format-vertical-align-top" aria-hidden="true"></span>
    </button>
    <button
      type="button"
      class="kv-ve-align__btn"
      :class="{ active: safeValue === 'middle' }"
      :title="resolvedMiddleTitle"
      :aria-label="resolvedMiddleTitle"
      :aria-pressed="safeValue === 'middle' ? 'true' : 'false'"
      @click="set('middle')"
    >
      <span class="mdi mdi-format-vertical-align-center" aria-hidden="true"></span>
    </button>
    <button
      type="button"
      class="kv-ve-align__btn"
      :class="{ active: safeValue === 'bottom' }"
      :title="resolvedBottomTitle"
      :aria-label="resolvedBottomTitle"
      :aria-pressed="safeValue === 'bottom' ? 'true' : 'false'"
      @click="set('bottom')"
    >
      <span class="mdi mdi-format-vertical-align-bottom" aria-hidden="true"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: "VeVerticalAlignPicker",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: String, default: "top" }, // top | middle | bottom
    label: { type: String, default: "" },
    topTitle: { type: String, default: "" },
    middleTitle: { type: String, default: "" },
    bottomTitle: { type: String, default: "" },
    allowEmpty: { type: Boolean, default: false }, // when true, clicking the active button clears value (inherit)
  },
  computed: {
    resolvedLabel() {
      return this.label || this.t("visual_editor-vertical_alignment");
    },
    resolvedTopTitle() {
      return this.topTitle || this.t("visual_editor-top");
    },
    resolvedMiddleTitle() {
      return this.middleTitle || this.t("visual_editor-middle");
    },
    resolvedBottomTitle() {
      return this.bottomTitle || this.t("visual_editor-bottom");
    },
    safeValue() {
      const v = String(this.value || "").toLowerCase();
      if (v === "top" || v === "middle" || v === "bottom") return v;
      return this.allowEmpty ? null : "top";
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    set(v) {
      if (this.allowEmpty && this.safeValue === v) {
        this.$emit("input", null);
        return;
      }
      this.$emit("input", v);
    },
  },
};
</script>

<style scoped lang="less">
/* Match VeAlignPicker visuals */
.kv-ve-align {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.kv-ve-align__btn {
  all: unset;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
  color: #344054;
}
.kv-ve-align__btn:hover {
  border-color: rgba(42, 170, 76, 0.55);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.12);
}
.kv-ve-align__btn.active {
  border-color: rgba(42, 170, 76, 0.85);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.16);
  background: rgba(42, 170, 76, 0.06);
  color: #027a48;
}
.kv-ve-align__btn .mdi {
  font-size: 18px;
  line-height: 1;
}
</style>


